
import React, { useEffect, useState } from 'react'
import PageBar from '../../dashboard/page-bar/PageBar'
import { FiSettings } from 'react-icons/fi'
import { getCityApi, getCountryApi, getCreateCompany, getImagePost, getLanguage, getStateApi } from '../../apifile/ApiFiles';
import { cloudinaryBaseUrl } from '../../login/baseUrl';

const AddCompanyMaster = () => {
    const [countryData, setCountryData] = useState()
    const [stateData, setStateData] = useState()
    const [cityData, setCityData] = useState()
    const [companyTypeData, setCompanyTypeData] = useState()
    const [languageData, setLanguageData] = useState()
    const [data, setData] = useState({
        // country: "India",
        // state: "Dadra and Nagar Haveli",
        // city: "Silvassa",
        // directory_name: "",
        // company_name: "",
        // mailing_name: "",
        // address1: "",
        // address2: "",
        // mobile_no: "",
        // fax_no: "",
        // email: "",
        // contact_name: "",
        // company_type: "",
        // domains: [],
        // financial_year: "",
        // books_from: "",
        // security_password: "",
        // use_security_control: false,
        // voucher_prefix: "",
        // voucher_sequence: "0",
        // base_currency: "",
        // format_name: "",
        // decimals: "0",
        // language: "",
        // print_mobile: "",
        // print_name: "",
        // print_email: "",

        // signup_right_desc: "",
        // signup_font_color: "#000000",
        // login_font_color: "#000000",

        // // File fields (optional: store as object or File)
        // logo: null,
        // signup_front_image: null,
        // signup_bg_image: null,
        // login_front_image: null,

        // // Add more if needed



        alias: "",
        directory: "",
        primary_mailing_name: "",
        address_line1: "",
        address_line2: "",
        state: "",
        city: "",
        country: "",
        faxNo: "",
        staffname: "",
        website: [],
        financialYear: "",
        bookBeginning: "",
        useSecurityCtrl: false,
        baseCurrencyInfo: "",
        formatName: "",
        suffixSymbol: false,
        addSpaceBet: false,
        amountInMil: false,
        numberOfDecimal: 0,
        vouPrefix: "",
        vouSequence: 0,
        language_id: "",
        name: "",
        mobile: "",
        email: "",
        password: "",
        companyType: "",
        domains: ["URL"],
        isActive: false,

        logo: '',
        sign_up_right_desciption: '',
        sign_up_front_image: '',
        sign_up_background_image: '',
        sign_up_left_description: '',
        sign_up_backround_color_image: '',
        sign_up_font_color: '',
        login_right_desciption: '',
        login_background_image: '',
        login_front_image: '',
        login_left_description: '',
        login_backround_color_image: '',
        login_font_color: '',


        firstname: "",
        lastname: '',
    });

    const onchangeHandle = (e) => {
        const { name, value, type, checked } = e.target;

        setData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };
    const changeHandler2 = (e) => {
        const { name, files } = e.target;

        if (files && files.length > 0) {
            setData((prev) => ({
                ...prev,
                [name]: files[0]
            }));
        }
    };


    // On input change
    useEffect(() => {
        if (data.domains.length === 0) {
            setData({ domains: [""] });
        }
    }, []);

    // Handle input change
    const handleDomainChange = (index, value) => {
        const updated = [...data.domains];
        updated[index] = value;
        setData({ domains: updated });
    };

    // Add row
    const addDomainRow = () => {
        setData((prev) => ({
            ...prev,
            domains: [...prev.domains, ""],
        }));
    };

    // Remove row
    const removeDomainRow = (index) => {
        const updated = data.domains.filter((_, i) => i !== index);
        setData({ domains: updated });
    };


    const comboDataGet = async () => {
        try {
            const res = await getCountryApi()
            // console.log(res?.data);
            setCountryData(res?.data)
            const resState = await getStateApi()
            setStateData(resState?.data)
            const resCity = await getCityApi()
            setCityData(resCity?.data)
            // const resCompanyType = await 
            const resLnag = await getLanguage()
            setLanguageData(resLnag?.data)
        } catch (error) {

        }
    }


    const handleChangeImage = async (e) => {
        const { name, files } = e.target
        const imageData = new FormData()
        imageData.append('image', files[0])

        try {
            const res = await getImagePost(imageData)
            setTimeout(() => {
                setData((prev) => ({
                    ...prev,
                    [name]: res.data?.url
                }))
            }, 1000);
        } catch (error) {
            console.error('Image Upload Error:', error)
        }
    }

    // Submit handler
    const handleSubmitData = async () => {
        try {
            const res = await getCreateCompany(data)
            console.log(res?.data);

        } catch (error) {

        }
    };

    useEffect(() => {
        comboDataGet()
    }, [])


    return (
        <div className="pageWrapper">
            <PageBar title="ADD Company Master" />
            <div className="pageTableWrapper">
                <div className="pageHeader">
                    <div className="pageTitle">
                        <FiSettings />
                        <h5>ADD  COMPANY</h5>
                    </div>
                </div>

                <div className="pageBody">
                    <div className="pageTable">

                        <form>
                            <div className="row">
                                {/* Country, State, City Dropdowns */}
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Country</label>
                                    <select className="form-select" name="country" value={data.country} onChange={onchangeHandle}>
                                        <option selected>Select Country</option>
                                        {countryData && countryData?.data?.map((item) => {
                                            return <option value={item?._id} key={item?._id}>{item?.country}</option>
                                        })}

                                    </select>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>State</label>
                                    <select className="form-select" name="state" value={data.state} onChange={onchangeHandle}>
                                        <option selected>Select State</option>
                                        {stateData && stateData?.data?.map((item) => {
                                            return <option value={item?._id} key={item?._id}>{item?.state}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>City</label>
                                    <select className="form-select" name="city" value={data.city} onChange={onchangeHandle}>
                                        <option selected>Select City</option>
                                        {cityData && cityData?.data?.map((item) => {
                                            return <option value={item?._id} key={item?._id}>{item?.city}</option>
                                        })}
                                    </select>
                                </div>

                                {/* Text Inputs */}
                                {/* {[
                                    'directory_name', 'company_name', 'mailing_name', 'address1', 'address2', 'mobile_no', 'fax_no', 'email', 'contact_name'
                                ].map((field, idx) => (
                                    <div key={idx} className="form-group mb-3 col-lg-4">
                                        <label>{field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</label>
                                        <input
                                            className="form-control"
                                            name={field}
                                            value={data[field] || ''}
                                            onChange={onchangeHandle}
                                        />
                                    </div>
                                ))} */}

                                <div className="form-group mb-3 col-lg-4">
                                    <label>Directory Name</label>
                                    <input type="text" className="form-control" name="directory" value={data.directory} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Company Name</label>
                                    <input type="text" className="form-control" name="name" value={data.name} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Mailing Name</label>
                                    <input type="text" className="form-control" name="primary_mailing_name" value={data.primary_mailing_name} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Address1</label>
                                    <input type="text" className="form-control" name="address_line1" value={data.address_line1} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Address2</label>
                                    <input type="text" className="form-control" name="address_line2" value={data.address_line2} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Mobile</label>
                                    <input type="number" className="form-control" name="mobile" value={data.mobile} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Fax No</label>
                                    <input type="number" className="form-control" name="faxNo" value={data.faxNo} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Email</label>
                                    <input type="email" className="form-control" name="email" value={data.email} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>First Name</label>
                                    <input type="text" className="form-control" name="firstname" value={data.firstname} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Last Name</label>
                                    <input type="text" className="form-control" name="lastname" value={data.lastname} onChange={onchangeHandle} />
                                </div>


                                {/* Company Type */}
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Select Company Type</label>
                                    <select className="form-select" name="companyType" value={data.companyType} onChange={onchangeHandle}>
                                        <option value="">Select Type</option>
                                        <option value="admin">Admin</option>
                                        <option value="user">User</option>
                                    </select>
                                </div>

                                {/* Domain Field */}
                                <div className="form-group mb-3 col-lg-8">
                                    <label>Company Domain</label>
                                    {data?.domains?.map((domain, index) => (
                                        <div key={index} className="d-flex mb-2">
                                            <input
                                                className="form-control"
                                                name={`domains${index}`}
                                                value={domain}
                                                onChange={(e) => handleDomainChange(index, e.target.value)}
                                                placeholder="Enter domain"
                                            />
                                            {data?.domains?.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger ms-2"
                                                    onClick={() => removeDomainRow(index)}
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    <button type="button" className="btn btn-success mt-2" onClick={addDomainRow}>
                                        Add More
                                    </button>
                                </div>

                                {/* Financial Year */}
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Financial Year From</label>
                                    <input type="date" className="form-control" name="financialYear" value={data.financialYear} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Books Beginning From</label>
                                    <input type="date" className="form-control" name="bookBeginning" value={data.bookBeginning} onChange={onchangeHandle} />
                                </div>

                                {/* Security Control */}
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Password</label>
                                    <input className="form-control" type="password" name="password" value={data.password} onChange={onchangeHandle} />
                                    <div className="form-check mt-2">
                                        <input className="form-check-input" type="checkbox" name="useSecurityCtrl" checked={data.useSecurityCtrl} onChange={onchangeHandle} />
                                        <label className="form-check-label">Use Security Control</label>
                                    </div>
                                </div>

                                {/* Voucher Settings */}
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Voucher Prefix</label>
                                    <input className="form-control" name="vouPrefix" value={data.vouPrefix} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Voucher Sequence</label>
                                    <input className="form-control" name="vouSequence" value={data.vouSequence} onChange={onchangeHandle} />
                                </div>

                                {/* Currency Settings */}
                                <div className="form-group mb-3 col-lg-6">
                                    <label>Base Currency Information</label>
                                    <input className="form-control" name="baseCurrencyInfo" value={data.baseCurrencyInfo} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Format Name</label>
                                    <input className="form-control" name="formatName" value={data.formatName} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Company Status</label>
                                    <select className="form-select" name="isActive" value={data.isActive} onChange={onchangeHandle}>
                                        <option value="">Select Company Status</option>
                                        <option value={true}>Active</option>
                                        <option value={false}>InActive</option>
                                    </select>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <div className="form-check mt-2">
                                        <input className="form-check-input" type="checkbox" name="suffixSymbol" checked={data.suffixSymbol} onChange={onchangeHandle} />
                                        <label className="form-check-label">Suffix Symbol to amount</label>
                                    </div>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <div className="form-check mt-2">
                                        <input className="form-check-input" type="checkbox" name="addSpaceBet" checked={data.addSpaceBet} onChange={onchangeHandle} />
                                        <label className="form-check-label">Add space b/w amount and symbol</label>
                                    </div>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <div className="form-check mt-2">
                                        <input className="form-check-input" type="checkbox" name="amountInMil" checked={data.amountInMil} onChange={onchangeHandle} />
                                        <label className="form-check-label">Amount in million</label>
                                    </div>
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Number of Decimals</label>
                                    <input className="form-control" name="numberOfDecimal" value={data.numberOfDecimal} onChange={onchangeHandle} />
                                </div>



                                {/* Print Language */}
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Select Language</label>
                                    <select className="form-select" name="language_id" value={data.language_id} onChange={onchangeHandle}>
                                        <option value="">Select</option>
                                        {languageData && languageData?.map((item) => {
                                            return <option value={item?._id}>{item?.lang}</option>
                                        })}
                                    </select>
                                </div>
                                {/* <div className="form-group mb-3 col-lg-4">
                                    <label>Mobile</label>
                                    <input className="form-control" name="mobile" value={data.mobile} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Name</label>
                                    <input className="form-control" name="name" value={data.name} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Email</label>
                                    <input className="form-control" name="email" value={data.email} onChange={onchangeHandle} />
                                </div> */}
                                <div>
                                    <strong>ADD COMPANY INFO : </strong>
                                </div>
                                {/* File Upload Section */}
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Logo</label>
                                    <input className="form-control" type="file" name="logo" onChange={handleChangeImage} />
                                    {data?.logo && <img src={`${cloudinaryBaseUrl}${data.logo}`} alt="Logo" className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}

                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Right Description</label>
                                    <input className="form-control" name="sign_up_right_desciption" value={data.sign_up_right_desciption} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Front Image</label>
                                    <input className="form-control" type="file" name="sign_up_front_image" onChange={handleChangeImage} />
                                    {data.sign_up_front_image && <img src={`${cloudinaryBaseUrl}${data.sign_up_front_image}`} className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}

                                </div>
                                {/* More images and color fields from screenshot */}
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Background Image</label>
                                    <input className="form-control" type="file" name="sign_up_background_image" onChange={handleChangeImage} />
                                    {data.sign_up_background_image && <img src={`${cloudinaryBaseUrl}${data.sign_up_background_image}`} className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Left Description</label>
                                    <input className="form-control" name="sign_up_left_description" value={data.sign_up_left_description} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Background Color Image</label>
                                    <input className="form-control" type="file" name="sign_up_backround_color_image" onChange={handleChangeImage} />
                                    {data.sign_up_backround_color_image && <img src={`${cloudinaryBaseUrl}${data.sign_up_backround_color_image}`} alt="Sign Up Color BG" className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}

                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Sign Up Font Color</label>
                                    <input className="form-control" type="color" name="sign_up_font_color" value={data.sign_up_font_color} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Right Description</label>
                                    <input className="form-control" name="login_right_desciption" value={data.login_right_desciption} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Background Image</label>
                                    <input className="form-control" type="file" name="login_background_image" onChange={handleChangeImage} />
                                    {data.login_background_image && <img src={`${cloudinaryBaseUrl}${data.login_background_image}`} alt="Login BG" className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Front Image</label>
                                    <input className="form-control" type="file" name="login_front_image" onChange={handleChangeImage} />
                                    {data.login_front_image && <img src={data.login_front_image} alt="Login Front" className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}
                                </div>

                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Left Description</label>
                                    <input className="form-control" name="login_left_description" value={data.login_left_description} onChange={onchangeHandle} />
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Background Color Image</label>
                                    <input className="form-control" type="file" name="login_backround_color_image" onChange={handleChangeImage} />
                                    {data.login_backround_color_image && <img src={`${cloudinaryBaseUrl}${data.login_backround_color_image}`} alt="Login Color BG" className="img-thumbnail mt-2" style={{ maxHeight: '150px' }} />}
                                </div>
                                <div className="form-group mb-3 col-lg-4">
                                    <label>Login Font Color</label>
                                    <input className="form-control" type="color" name="login_font_color" value={data.login_font_color} onChange={onchangeHandle} />
                                </div>
                                {/* Submit Buttons */}
                                <div className="form-group mb-3 col-lg-12 d-flex justify-content-center">
                                    {/* <button type="button" className="btn btn-danger me-2">Cancel</button> */}
                                    <button type="button" className="btn btn-success" style={{ width: '150px' }} onClick={handleSubmitData}>Add</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddCompanyMaster